/**
 * Route paths, kept in a module of their own deliberately.
 *
 * `app.routes.ts` builds its guards at module scope, and `auth.config.ts` needs a path to redirect
 * to. Having the latter import the former made the two a cycle, which only stayed harmless for as
 * long as `app.routes.ts` happened to be evaluated first - whichever module the bundle enters
 * second hands out half-initialised bindings, and reading one at module scope is a ReferenceError.
 * This module imports nothing, so it cannot take part in a cycle.
 */
export const overviewPath = `overzicht`;
export const trafficPath = `verkeer`;
export const roadworksPath = `wegwerkzaamheden`;
export const userPath = `user`;
export const statisticsPath = `statistieken`;
export const timelineSnapshotPath = `snapshot/tijdlijn`;
export const mapSnapshotPath = `snapshot/kaart`;
export const settingsPath = `instellingen`;
